import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Segment, Container, Header } from 'semantic-ui-react'
import _ from 'lodash'

import { getCurPatientData } from 'stores/Account/Select'
import PatientSwitch from 'components/PatientSwitch'

import { mergeStyles } from '@enlyt/base/helpers/mergeStyles'
import { useTheme } from 'contexts/ThemeProvider'

import themeStyles from './styles'
import { localization } from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const TopBanner = props => {
  const { t } = props
  const style = _.get(props, 'style')
  const pageName = _.get(props, 'pageName')
  const isSimple = _.get(props, 'isSimple', false)
  const page = _.get(props, 'page', '')
  const { theme, isDark } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = useMemo(() => {
    return mergeStyles(defaultStyles, style)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- defaultStyles from themeStyles(theme)
  }, [style, isDark])
  const curPatient = useSelector(getCurPatientData)

  return (
    <Segment style={_.merge(styles.container, style)} vertical>
      <Container style={styles.content}>
        <Header as='h1' style={styles.mainTitle}>
          {pageName}
        </Header>
        {!isSimple && (
          <div style={styles.label}>
            <span>
              {page === 'appointments'
                ? `${t('viewingAppointmentsOf')} `
                : `${t('viewingHealthRecordFor')} `}{' '}
            </span>
            <strong style={styles.marginRight}>
              {_.get(curPatient, 'firstname')?.toUpperCase()}
            </strong>
            <PatientSwitch switchButtonStyle={styles.patientSwitchButton} />
          </div>
        )}
      </Container>
    </Segment>
  )
}

export default withLocalization(TopBanner, localization)
